var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Plus step/Default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    rx: 14
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBBCMC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-up-start",
    transform: "translate(-1021.000000, -493.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(950.000000, 493.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus-step/Default",
    transform: "translate(71.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Rectangle",
    stroke: "#C4C4C4",
    mask: "url(#mask-2)",
    strokeWidth: 4,
    strokeDasharray: 4,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(33.277311, 31.260504)",
    fill: "#C4C4C4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 25.8655462,
    y: 0,
    width: 5.74789916,
    height: 57.4789916,
    rx: 2.87394958
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7394958,6.75015599e-14 C30.3267343,6.72099889e-14 31.6134454,1.28671106 31.6134454,2.87394958 L31.6134454,54.605042 C31.6134454,56.1922805 30.3267343,57.4789916 28.7394958,57.4789916 C27.1522573,57.4789916 25.8655462,56.1922805 25.8655462,54.605042 L25.8655462,2.87394958 C25.8655462,1.28671106 27.1522573,6.77931309e-14 28.7394958,6.75015599e-14 Z",
    id: "Rectangle-Copy",
    transform: "translate(28.739496, 28.739496) rotate(-270.000000) translate(-28.739496, -28.739496) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add_icon.0625fefc2f80cc619e8f4a6df37124d0.svg";
export { ForwardRef as ReactComponent };